import {action, observable} from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import {joinUrl} from "@utils/index";

export default class deviceStatusState extends baseState {
    @observable list = {};
    @action
    setList = data => {
        console.log(data.records);
        for (var i = 0; i < data.records.length; i++) {
            data.records[i].id = i + "";
        }
        this.list = data;
    };

    getList = data => {
        return this.fetch({
            url: apiUrl.LOG.DEVICE_STATUS.LIST,
            method: 'get',
            setState: "setList",
            data
        });
    }
}
